import { render, staticRenderFns } from "./AsideItem.vue?vue&type=template&id=03060a3e&"
import script from "./AsideItem.vue?vue&type=script&lang=js&"
export * from "./AsideItem.vue?vue&type=script&lang=js&"
import style0 from "./AsideItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports